<template>
    <div>
        <!-- projects -->
	<div class="portfolio">
		<div class="container animate__animated   animate__backInRight"> 
			<div class="w3ls-title   animation-duration: 2s"> 
				<h2 class="agileits-title w3title1">研发管线</h2>
			</div>
			<div class="wthree_services_grids ">	
				<!-- <ul class="simplefilter">
					<li  data-filter="1" v-for="(item, index) in dictlist" :key="index">{{item.dictLabel}}</li>
				</ul> -->
        
				<div class="filtr-container">
					<div class="col-md-4 col-sm-4 col-xs-6 agi-pro filtr-item  animate__fadeIn " data-category="1" data-sort="" v-for="(item, index) in images" :key="index">
						<div class="agileits_portfolio_grid  animate__bounceIn animate__bounceIn">
								<el-image 
                 :preview-src-list="imageslist"
                class="img-responsive" :src="item.img" alt=""   no-repeat style="object-fit: fill; height:100%; width:100%;"  /> 
						</div>
					</div>
				<div class="clearfix"> </div>
				</div>
			</div>
		</div>
	</div>
	<!-- //projects --> 
   
    </div>
</template>
<style scoped>
.col-md-4 {
  animation: bounceIn; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 2s; /* don't forget to set a duration! */
}
li {
  animation: bounceIn; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 2s; /* don't forget to set a duration! */
}
</style>
<script>
import 'animate.css'
import * as  http from '@/request/http'
import { useRouter} from 'vue-router';
import { useStore } from 'vuex';
import Pagination from '@/components/PaginationCom.vue';

export default {
   components: {
    //   Pagination
    },
   data(){
    return {    
      currentPage: 1,
      pageSize: 10000,
      totalItems: 1,  
      dictlist:[],
      dictsdata:{},
      imageslist:[ 'images/gx/20250220104309.jpg' ,  'images/gx/20250220105710.png',  'images/gx/20250220105719.png'  ],
      images:[{img: 'images/gx/20250220104309.jpg',name:"点击看大图"},{img: 'images/gx/20250220105710.png',name:"点击看大图"},{img: 'images/gx/20250220105719.png',name:"点击看大图"}]
    }
   },
   methods: {
    handlePageChanged(newPage) {
       let  param = {
           dictType: 'sys_pipeline_type',
           currentPage: this.currentPage,
       }
        this.currentPage = newPage;
        http.dicts.dictlist(param).then(res=>{
           console.log(res.data) 
           this.dictsdata = res.data,
           this.dictlist=res.data.rows
           this.currentPage =newPage;
           this.pageSize=10;
           this.totalItems=res.data.total
        })
      },
   },
   created(){
    this.handlePageChanged(1)
 
   },
 
  setup() {
    const router = useRouter();
    // 使用全局$store
    const store = useStore();
 
    function gotoDetail(item) {
      const state= item
      store.state.productStore.currentProduct=item
      router.push({ name: 'productDetail',state});
    }
    return {
      gotoDetail
    };
  }
}
</script>
